<template>
  <b-modal refs="quick-print-modal" v-model="showLocal" id="quick-print" modal-class="modal--edit" hide-footer>
    <iframe :src="quickPrintUrl"> </iframe>
  </b-modal>
</template>

<script>
  export default {
    name: "QuickPrint",
    props: {
      show: {
        type: Boolean,
        default: false
      },
      fileId: {
        type: [Number, String],
        required: true
      },
    },
    methods:{
      close(){
        this.$emit('hide', false)
      },
    },

    computed:{
      quickPrintUrl () {
        return  window.baseURL + '/quickprint?file_id=' + this.fileId + '&app';
      },
      showLocal: {
        get: function() {
          return this.show
        },
        set: function() {
          this.close()
        }
      }
    }
  }
</script>

<style  lang="scss">
  #quick-print{
    .modal-dialog{
      max-width: 1300px;
      max-height: 800px;
    }
    .modal-content{
      height: 640px;
    }

    iframe{
      width: 100%;
      height: 100%;
      border: 0;
      position: absolute;
      left: 0;
      top: 0;
      //padding: 15px;
      border-radius: 8px;
    }
  }

</style>
